import { ApolloError } from '@apollo/client';
import React from 'react';

import { GlobalError } from '@/components/global-error';
import { JobDetailQuery } from '@/graphql/generated';

import { JobNotAvailable } from '../components/job-not-available';

type UnauthorizedReason = 'PRIVATE' | 'PROJOBS';

const isUnauthorized = (reason: UnauthorizedReason) => (data?: JobDetailQuery) =>
  data?.job?.__typename === 'UnauthorizedJob' && data?.job?.reason === reason;

export const isFencedProjobs = isUnauthorized('PROJOBS');
export const isPrivate = isUnauthorized('PRIVATE');

type QueryDataArg = {
  error?: ApolloError;
  data?: JobDetailQuery;
};

export const getClientErrorComponent = ({ error, data }: QueryDataArg): React.ReactElement | undefined => {
  if (error) return <GlobalError type="500" />;
  if (!data?.job) return <JobNotAvailable />;
};

export const getServerErrorComponent = ({ error, data }: QueryDataArg): React.ReactElement | undefined => {
  if (error) {
    throw error;
  }

  if (!data?.job) return <JobNotAvailable />;
};
